function errorCode(error: unknown): string | undefined {
    if (!error || typeof error !== 'object') return undefined
    const awsError = error as { code?: string; name?: string }
    return awsError.code || awsError.name
}

export function describeError(error: unknown): string {
    switch (errorCode(error)) {
        case 'ExpiredTokenException':
        case 'UnrecognizedClientException':
        case 'InvalidSignatureException':
            return 'Sesja AWS wygasła lub jest nieprawidłowa. Zaloguj się ponownie.'
        case 'ForbiddenException':
        case 'UnauthorizedException':
        case 'AccessDeniedException':
            return 'Brak uprawnień AWS do wykonania tej operacji.'
        case 'ResourceNotFoundException':
            return 'Ta maszyna nie udostępnia tej konfiguracji.'
        case 'ConflictException':
            return 'Konfiguracja zmieniła się w trakcie zapisu. Otwórz maszynę ponownie i sprawdź aktualne wartości.'
        case 'RequestEntityTooLargeException':
            return 'Konfiguracja przekracza limit rozmiaru shadowa AWS. Zmiany nie zostały zapisane.'
        case 'NetworkingError':
        case 'TimeoutError':
            return 'Nie udało się potwierdzić operacji. Sprawdź połączenie i ponów próbę.'
        default:
            return error instanceof Error ? error.message : 'Nie udało się wykonać operacji AWS.'
    }
}
